import { Link } from "react-router-dom";
import { MapPin, Mail } from "lucide-react";

const cols = [
  {
    title: "Products",
    links: [
      { to: "/products/vyayanhub", label: "VyayanHub" },
      { href: "https://vyayamhub.com", label: "vyayamhub.com", external: true },
      { to: "/products/society-management", label: "Society Management" },
      { to: "/products/restaurant-management", label: "Restaurant Management" },
    ],
  },
  {
    title: "Services",
    links: [
      { to: "/services/custom-software-development", label: "Custom Software Development" },
      { to: "/services/cloud-solutions", label: "Cloud Solutions" },
      { to: "/services/salesforce-development", label: "Salesforce Development" },
      { to: "/services/data-and-ai", label: "Data & AI" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/about", label: "About" },
      { to: "/insights", label: "Insights" },
      { to: "/contact", label: "Contact" },
      { to: "/privacy-policy", label: "Privacy Policy" },
      { to: "/terms-of-service", label: "Terms of Service" },
      { to: "/cookie-policy", label: "Cookie Policy" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-gray-200 bg-[#F8F9FA]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-8 w-8 items-center justify-center rounded-sm bg-brand font-heading text-lg font-bold text-white">A</span>
              <span className="font-heading text-xl font-bold tracking-tight text-gray-950">
                Adika<span className="text-brand"> Tech</span>
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-gray-600">
              A Mumbai software studio building focused products for Indian businesses — and custom
              engineering for teams that have outgrown spreadsheets.
            </p>
            <div className="mt-6 space-y-2 text-sm text-gray-600">
              <a href="mailto:hello@adikatech.com" data-testid="footer-email" className="flex items-center gap-2 transition-colors duration-200 hover:text-brand">
                <Mail className="h-4 w-4 text-brand" aria-hidden="true" /> hello@adikatech.com
              </a>
              <p className="flex items-center gap-2" data-testid="footer-location">
                <MapPin className="h-4 w-4 text-brand" aria-hidden="true" /> Mumbai, Maharashtra, India
              </p>
            </div>
          </div>
          {cols.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-gray-400">{col.title}</h3>
              <ul className="mt-5 space-y-3">
                {col.links.map((link) => (
                  <li key={link.to || link.href}>
                    {link.external ? (
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-vyayamhub-external"
                        className="text-sm text-gray-600 transition-colors duration-200 hover:text-gray-950"
                      >
                        {link.label} ↗
                      </a>
                    ) : (
                      <Link
                        to={link.to}
                        data-testid={`footer-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                        className="text-sm text-gray-600 transition-colors duration-200 hover:text-gray-950"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 flex flex-col gap-3 border-t border-gray-200 pt-8 text-xs text-gray-500 sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} Adika Tech. All rights reserved.</p>
          <p>Built in Mumbai, for businesses across India.</p>
        </div>
        <p className="mt-4 text-[11px] leading-relaxed text-gray-400" data-testid="footer-trademark-note">
          Salesforce, Sales Cloud and Service Cloud are trademarks of Salesforce, Inc. Adika Tech is not
          affiliated with, certified by, or endorsed by Salesforce, Inc.
        </p>
      </div>
    </footer>
  );
}
